import { render } from "./VUEAppContentDashboard.vue?vue&type=template&id=6c128a7c"
import script from "./VUEAppContentDashboard.vue?vue&type=script&lang=js"
export * from "./VUEAppContentDashboard.vue?vue&type=script&lang=js"

import "./VUEAppContentDashboard.vue?vue&type=style&index=0&id=6c128a7c&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__